module.exports = __webpack_public_path__ + "static/media/success.fd3dca83.png";